import * as React from "react";
import { cn } from "@/lib/utils";

// Tri-state selector: "SI" | "NO" | "NI" (Non Indicato).
// Legacy boolean values from older records are coerced on read.
const toTri = (v) => {
  if (v === true || v === "SI") return "SI";
  if (v === false || v === "NO") return "NO";
  return "NI";
};

const OPTIONS = [
  { key: "SI", label: "Sì", activeClass: "bg-[#34C759] text-white" },
  { key: "NI", label: "NI", activeClass: "bg-slate-500 text-white" },
  { key: "NO", label: "No", activeClass: "bg-[#FF3B30] text-white" },
];

const TriStateSwitch = React.forwardRef(({ value, onValueChange, className, testId, ...rest }, ref) => {
  const current = toTri(value);
  return (
    <div
      ref={ref}
      role="radiogroup"
      data-testid={testId}
      className={cn(
        "inline-flex items-center rounded-full bg-white border border-slate-200 p-0.5 shadow-sm",
        className
      )}
      {...rest}
    >
      {OPTIONS.map((opt) => {
        const active = current === opt.key;
        return (
          <button
            key={opt.key}
            type="button"
            role="radio"
            aria-checked={active}
            data-state={active ? "on" : "off"}
            data-testid={testId ? `${testId}-${opt.key.toLowerCase()}` : undefined}
            onClick={() => onValueChange && onValueChange(opt.key)}
            className={cn(
              "h-6 px-2.5 rounded-full text-[11px] font-semibold uppercase tracking-wider transition-all leading-none min-w-[32px]",
              active ? opt.activeClass : "text-slate-500 hover:text-slate-900"
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
});
TriStateSwitch.displayName = "TriStateSwitch";

export { TriStateSwitch, toTri };
